import { render, staticRenderFns } from "./BenefitForm.vue?vue&type=template&id=530b0c9f&"
import script from "./benefit_form.js?vue&type=script&lang=js&"
export * from "./benefit_form.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports